export const DOS_PI = Math.PI * 2;
